import { render, staticRenderFns } from "./_add-story.vue?vue&type=template&id=1ab4a88a&"
import script from "./_add-story.vue?vue&type=script&lang=js&"
export * from "./_add-story.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports